import React from 'react';
import styles from './PopUpAdminComponent.module.css';

const PopUpAdminComponent = ({ title, children, onClose }) => {
    return (
        <div className={styles.overlay}>
            <div className={styles.popup}>
                <div className={styles.header}>
                    <h1 className={styles.title}>{title}</h1>
                    <button onClick={onClose} className={styles.closeButton}>✕</button>
                </div>
                <div className={styles.content}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default PopUpAdminComponent;
